<!-- Manage -->
<div class="manage-page p-6 md:p-10 space-y-6 bg-primary-50">

  <!-- Page header -->
  <header class="flex items-center gap-4">
    <button type="button"
            (click)="home()"
            class="inline-flex items-center justify-center w-20 h-20 rounded-xl border border-primary-200 hover:bg-gray-50 focus:outline-none focus:ring"
            aria-label="Home">
      <i class="pi pi-home !text-5xl"></i>
    </button>

    <div class="flex-1">
      <h1 class="text-2xl md:text-3xl font-bold tracking-tight">Manage</h1>
      <p class="text-sm text-gray-500">Management functionality for your account</p>
    </div>
  </header>

  <!-- Actions grid -->
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
    <!-- Download Notes -->
    <article class="group rounded-2xl border !bg-primary-100 border-gray-200 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-primary-200">
          <i class="pi pi-cloud-download text-emerald-600  !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Download All Notes (JSON)</h2>
          <p class="text-sm text-gray-500">Export a full data dump for backup or migration.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="downloadNotesDB()"
                class="px-3 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 focus:outline-none focus:ring !text-xl">
          Download JSON
        </button>
      </div>
    </article>

    <!-- Export PDF
    <article class="group rounded-2xl border !bg-primary-100 border-gray-200 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-rose-50">
          <i class="pi pi-file-pdf text-rose-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Export to PDF</h2>
          <p class="text-sm text-gray-500">Generate a printable PDF from your notes.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="exportPDF()"
                class="px-3 py-2 rounded-lg bg-rose-600 text-white hover:bg-rose-700 focus:outline-none focus:ring">
          Export PDF
        </button>
      </div>
    </article> -->

    <!-- Manage Spaces -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-indigo-50">
          <i class="pi pi-sitemap text-indigo-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Manage Spaces</h2>
          <p class="text-sm text-gray-500">List your Spaces, switch the active one, edit, or create a new one.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToManageSpaces()"
                class="px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring">
          Space Manager
        </button>
      </div>
    </article>

    <!-- My private tags (a Space's own tags are managed in that Space: Manage Spaces → Edit) -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-teal-50">
          <i class="pi pi-lock text-teal-600 !text-3xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">My Private Tags</h2>
          <p class="text-sm text-gray-500">Tags only you can see. A Space's shared tags are managed in Manage Spaces.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToEditTags()"
                class="px-3 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700 focus:outline-none focus:ring">
          Private Tags
        </button>
      </div>
    </article>

    <!-- Manage Attachments -->
    <article class="group rounded-2xl border border-gray-200 !bg-primary-100 p-5 shadow-sm hover:shadow-md transition">
      <div class="flex items-start gap-3">
        <span class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-orange-50">
          <i class="pi pi-paperclip text-orange-600 !text-5xl"></i>
        </span>
        <div class="flex-1">
          <h2 class="font-semibold">Manage Attachments</h2>
          <p class="text-sm text-gray-500">View, download, rename, and delete attachments across all notes.</p>
        </div>
      </div>
      <div class="mt-4">
        <button type="button"
                (click)="goToManageAttachments()"
                class="px-3 py-2 rounded-lg bg-orange-600 text-white hover:bg-orange-700 focus:outline-none focus:ring">
          Attachment Manager
        </button>
      </div>
    </article>
  </section>

</div>
